export default [
    {
        path: 'convql/queries',
        name: 'list-convql-queries',
        component: () => import('pages/convql/list'),
    },
    {
        path: 'convql/queries/new',
        name: 'create-convql-query',
        component: () => import('pages/convql/create'),
    },
    {
        path: 'convql/query/:queryId',
        name: 'edit-convql-query',
        component: () => import('pages/convql/create'),
    },
];
